import { forwardRef, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { UsersApi } from '@core/api/users/users.api';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime, skip, switchMap } from 'rxjs/operators';
import english from '../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../main/maintenances/i18n/pt.json';
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return AssigneesComponent; }),
    multi: true
};
var AssigneesComponent = /** @class */ (function () {
    function AssigneesComponent(fuseTranslationLoaderService, usersApi) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.usersApi = usersApi;
        this.required = false;
        this.disabled = false;
        this.floatLabel = true;
        this.appearance = 'outline';
        this.assignees = [];
        this.inputValue = new FormControl();
        this.loading = false;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    AssigneesComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.required) {
            this.inputValue.setValidators(Validators.required);
        }
        if (this.disabled) {
            this.inputValue.disable();
        }
        this.inputValue.valueChanges.pipe(skip(1), debounceTime(500), switchMap(function (searchTerm) {
            _this.loading = true;
            _this.assignees = [];
            return _this.usersApi.search({ name_contains: searchTerm, type_in: ['all', 'admin'], archived: false }, { orderColumn: 'name', order: 'asc' });
        })).subscribe(function (response) {
            _this.loading = false;
            _this.assignees = response.items;
        });
    };
    AssigneesComponent.prototype.writeValue = function (assignee) {
        var _this = this;
        if (assignee && assignee.id) {
            this.usersApi.searchOne(assignee.id).subscribe(function (requester) {
                _this.selectedAssignee = requester;
                _this.inputValue.setErrors(null);
            });
            return;
        }
        this.deselectAssignee();
    };
    AssigneesComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    AssigneesComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    AssigneesComponent.prototype.setSelectedAssignee = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.selectedAssignee = this.assignees.find(function (requester) { return (requester.id === _this.inputValue.value); });
            this.onChange(this.selectedAssignee);
            this.inputValue.setErrors(null);
        }
    };
    AssigneesComponent.prototype.deselectAssignee = function () {
        this.onChange(null);
        this.inputValue.setValue(null);
        this.inputValue.setErrors(null);
        this.selectedAssignee = null;
    };
    return AssigneesComponent;
}());
export { AssigneesComponent };
